function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import Dropzone from 'react-dropzone';
import KZUIComponent from '../../base';
import './style.less';

var Large = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Large, _KZUIComponent);

  var _super = _createSuper(Large);

  function Large() {
    _classCallCheck(this, Large);

    return _super.apply(this, arguments);
  }

  _createClass(Large, [{
    key: "render",
    value: function render() {
      var clsPrefix = 'kui-file-select-large';
      var style = {
        width: '338px',
        height: '198px'
      };
      return /*#__PURE__*/React.createElement(Dropzone, {
        onDrop: this.props.onDrag,
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--container"),
        onClick: this.props.onClick
      }, this.props.children, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--drag")
      }, this.props.text), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--ext")
      }, "\u652F\u6301\u6269\u5C55\u540D\uFF1A.png .jpg .jpeg .gif..."), this.props.bottom ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--bottom")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--bottomele1"),
        onClick: this.props.replaceImg
      }, /*#__PURE__*/React.createElement("span", null, "\u66FF\u6362")), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--bottomele2"),
        onClick: this.props.deleteImg
      }, /*#__PURE__*/React.createElement("span", null, "\u5220\u9664"))) : null));
    }
  }]);

  return Large;
}(KZUIComponent);

export default Large;